import React from "react";
import { MantineProvider } from "@mantine/core";

import { Header } from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";
import ContactSection from "./components/ContactSection";

const theme = {};

const ContactPage = () => {
  return (
    <MantineProvider theme={theme}>
      {Header()}
      <ContactSection />
      {Footer()}
    </MantineProvider>
  );
};

export default ContactPage;
